import type { ReactNode } from 'react';
import './about-hero.scss';
import type { AboutHeroData } from '../../../interfaces/about';

interface AboutHeroProps extends AboutHeroData {
  children?: ReactNode;
  imageAlt?: string;
  eyebrow?: string;
  content?: ReactNode;
  [key: string]: unknown;
}

export function AboutHero({
  hero_title,
  hero_subtitle,
  hero_video,
  children,
  content,
}: AboutHeroProps) {

  const heroTitle = hero_title;
  const heroSubtitle = hero_subtitle;
  const heroVideoSrc = hero_video;
  return (
    <section className='about-hero'>
      <div className="about-hero-wrapper">
        <div className="about-hero-content">
          {heroTitle && <h2 className="about-hero-title">{heroTitle}</h2>}
          {heroSubtitle && <p className="about-hero-subtitle">{heroSubtitle}</p>}
          {content}
          {children}
        </div>
      {heroVideoSrc && (
          <div className="about-hero-media">
            <section className='about-hero-video-container'>
            <video src={`/api/assets/${hero_video}`}
                autoPlay
                muted
                loop
                playsInline
                controls
              >
            </video>
            </section>
          </div>
        )}



      </div>
    </section>
  );
}
